import { Component, OnInit } from '@angular/core';
import { JeevesSalesCartListComponent, JeevesSalesCartListRow } from 'gung-standard-jeeves';
import {
  ProductService,
  CartService,
  Product,
  PriceService,
  AvailabilityService,
  SelectedCustomerService,
  AuthService,
  CartRow,
  GungModalService,
  CalendarDate,
  Availability,
  CartRowPrice,
  Customer,
  GungFlowService
} from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';
import { format, parse } from 'date-fns';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { environment } from './../../../../../environments/environment';
import { CreditCheckAmout, HeloCreditCheckService } from './../../../../services/helo-credit-check.service';

@Component({
  selector: 'tylo-helo-jeeves-sales-cart-list',
  templateUrl: './helo-jeeves-sales-cart-list.component.html',
  styleUrls: ['./helo-jeeves-sales-cart-list.component.css']
})
export class HeloJeevesSalesCartListComponent extends JeevesSalesCartListComponent implements OnInit {
  selectedLanguageCode: string;
  isUser = false;

  deliveryDate = new Date();
  minDeliveryDate = new Date();
  currentCustomer: Customer;
  amountOfCredit: CreditCheckAmout;

  constructor(
    protected authService: AuthService,
    protected productService: ProductService,
    protected cartService: CartService,
    protected priceService: PriceService,
    protected availabilityService: AvailabilityService,
    protected selectedCustomerService: SelectedCustomerService,
    protected dateUtilService: DateUtilService,
    protected translateService: TranslateService,
    private gungModalService: GungModalService,
    protected creditCheckService: HeloCreditCheckService,
    protected flowService: GungFlowService
  ) {
    super(productService, cartService, priceService, availabilityService, selectedCustomerService, dateUtilService, flowService);
  }

  ngOnInit() {
    this.selectedCustomerService
      .getSelectedCustomer()
      .pipe(first())
      .subscribe(customer => (this.currentCustomer = customer));
    addWorkdays(this.minDeliveryDate, 5);
    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(currentUser => {
        if (currentUser.roles.includes('USER') && currentUser.roles.length === 1) {
          this.isUser = true;
        }

        super.ngOnInit();
        this.selectedLanguageCode = this.translateService.currentLang || 'se';
      });
  }

  updateData() {
    super.updateData();
  }

  updateMappedData(d: JeevesSalesCartListRow[]) {
    super.updateMappedData(d);
    this.creditCheck();
  }

  creditCheck() {
    this.amountOfCredit = null;
    this.creditCheckService.getAmountOfCredit(this.currentCustomer.id).subscribe(amountOfCredit => {
      const total = this.calculateTotalValue();
      if (amountOfCredit.creditLeft < total) {
        this.amountOfCredit = amountOfCredit;
      }
    });
  }

  editNote(row: CartRow): void {
    let noteInput = '';
    if (!!row.extra.orp) {
      noteInput = row.extra.orp.orpradtext || '';
    }

    this.gungModalService.openEditNoteModal(noteInput).then(
      (result: any) => {
        if (!!result && result.hasOwnProperty('note')) {
          this.cartService.setExtra(
            row.productId,
            {
              orp: {
                orpradtext: result.note
              }
            },
            row.targetStockId,
            row.productPartialId
          );
        }
      },
      reason => {}
    );
  }

  dateSelected(event) {
    const date = event.date;
    for (const row of this.mappedData) {
      const dateFortmated = format(date, 'yyyy-MM-dd');
      row.deliveryDate = dateFortmated;
      this.cartService.setExtra(
        row.productId,
        {
          orp: {
            ordberlevdat: dateFortmated
          }
        },
        row.targetStockId,
        row.productPartialId
      );
    }
  }

  restoreMinDate() {
    for (const row of this.mappedData) {
      const rowDate = new Date(row.minDate.year, row.minDate.month - 1, row.minDate.day);

      this.cartService.removeExtraField(row.productId, 'orp.ordberlevdat', row.targetStockId);
      const dateFortmated = format(rowDate, 'yyyy-MM-dd');
      row.deliveryDate = dateFortmated;
      this.cartService.setExtra(
        row.productId,
        {
          orp: {
            ordberlevdat: dateFortmated
          }
        },
        row.targetStockId,
        row.productPartialId
      );
    }
    this.deliveryDate = new Date();
  }

  updateDeliveryDate(row: JeevesSalesCartListRow, selectedDeliveryDate) {
    const oldVal = row.deliveryDate || row.minDate;

    const deliveryDate = format(selectedDeliveryDate.date, 'yyyy-MM-dd');

    if (oldVal === deliveryDate) {
      return;
    }

    if (!deliveryDate) {
      this.cartService.removeExtraField(row.productId, 'orp.ordberlevdat', row.targetStockId);
      return;
    }

    this.cartService.setExtra(
      row.productId,
      {
        orp: {
          ordberlevdat: deliveryDate
        }
      },
      row.targetStockId,
      row.productPartialId
    );
  }

  public mapData(
    products: Product[],
    prices: CartRowPrice[],
    availabilities: Availability[],
    cartRows: CartRow[],
    customer: Customer
  ): JeevesSalesCartListRow[] {
    const cartRowsSuper = super.mapData(products, prices, availabilities, cartRows, customer);

    const now = new Date();
    let minDate = new NgbDate(now.getFullYear(), now.getMonth() + 1, now.getDate());
    for (const row of cartRowsSuper) {
      if (row.minDate.after(minDate)) {
        minDate = row.minDate;
      }
    }
    this.deliveryDate = new Date(minDate.year, minDate.month - 1, minDate.day);
    now.setDate(now.getDate() + 2);
    if (this.deliveryDate < now) {
      this.deliveryDate = now;
    }

    return cartRowsSuper;
  }

  duplicateProduct(row: JeevesSalesCartListRow, index: number) {
    if (!row.cartRow.productPartialId) {
      // this.cartService.removeRow(row.related[0].cartRow);
      // this.cartService.addToCart(row.related[0].product.id, row.related[0].cartRow.qty, row.related[0].cartRow.targetStockId, row.related[0].product.id + '_' + 0);
      this.cartService.setProductPartialId(row.product.id, row.cartRow.targetStockId, row.product.id + '_' + 0);
    }
    const productPartialId = row.product.id + '_' + new Date().getTime();
    this.cartService.addToCart(
      row.product.id,
      1 || row.cartRow.qty,
      row.cartRow.targetStockId,
      productPartialId,
      index + 1
    );

    this.updateData();
    // this.updateDataContext(row.related[0].product.id, row.related[0].cartRow.qty, false, productPartialId);
  }
}
function addWorkdays(date: Date, days: number) {
  let daysRemaining = days;
  while (daysRemaining > 0) {
    date.setDate(date.getDate() + 1);
    if (date.getDay() !== 0 && date.getDay() !== 6) {
      daysRemaining--;
    }
  }
}
